// extracted by mini-css-extract-plugin
export var dropdownIcon = "_re-6";
export var imgContainer = "_re-3";
export var menuIcon = "_re-5";
export var pillWrapper = "_re-2";
export var pillsContainer = "_re-1";
export var subscriptionCard = "_re-0";
export var subscriptionLogo = "_re-4";